/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Workflow_ExcelInputs */

const en_gc_resources_compare_workflow_excel = /** @type {(inputs: Gc_Resources_Compare_Workflow_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop files and OneDrive collaboration`)
};

const zh_gc_resources_compare_workflow_excel = /** @type {(inputs: Gc_Resources_Compare_Workflow_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌面文件与 OneDrive 协作`)
};

/**
* | output |
* | --- |
* | "Desktop files and OneDrive collaboration" |
*
* @param {Gc_Resources_Compare_Workflow_ExcelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_workflow_excel = /** @type {((inputs?: Gc_Resources_Compare_Workflow_ExcelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Workflow_ExcelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_workflow_excel(inputs)
	return zh_gc_resources_compare_workflow_excel(inputs)
});
export { gc_resources_compare_workflow_excel as "gc.resources.compare.workflow.excel" }